import { selectUserInfos } from "domain/auth/auth.selectors";
import { HiOutlineCheck } from "react-icons/hi";
import { useAppSelector } from "ui/hook/store";
import { translate } from "ui/i18n";

export function SubscriptionInfos() {
  const user = useAppSelector(selectUserInfos);
  return (
    <div className="p-4 py-6 md:p-6">
      <div
        className={`mb-6 w-fit rounded-[36px] px-4 py-1 text-base font-semibold ${
          user?.isPremium
            ? "bg-pink-400 text-white"
            : "bg-darkGrey-200 text-secondaryGrey-800"
        }`}
      >
        {translate(`ns1:Account.${user?.isPremium ? "Premium" : "Free"}`)}
      </div>
      <div className=" space-y-4">
        {user?.isPremium
          ? [...Array(5)].map((_, index) => (
              <div
                className="flex space-x-3 text-sm font-medium text-darkGrey-700 md:text-base"
                key={index}
              >
                <div className="me-2 h-6 w-6">
                  <HiOutlineCheck color="#E14277" size={24} />
                </div>
                {translate(
                  `ns1:Account.PremiumFuncs.Func${
                    (index + 1) as 1 | 2 | 3 | 4 | 5
                  }`
                )}
              </div>
            ))
          : [...Array(4)].map((_, index) => (
              <div
                className="flex space-x-3 text-sm font-medium text-darkGrey-700 md:text-base"
                key={index}
              >
                <div className="me-2 h-6 w-6">
                  <HiOutlineCheck color="#E14277" size={24} />
                </div>
                {translate(
                  `ns1:Account.FreeFuncs.Func${(index + 1) as 1 | 2 | 3 | 4}`
                )}
              </div>
            ))}
      </div>
    </div>
  );
}
